module.exports = __webpack_public_path__ + "static/media/IMG_18877.e3c161bd.JPG";